const { v4 } = require('uuid');
const {
  getGradationColors,
  getRandomColor,
} = require('cgoing-utils-randomcolor');
const getDurationToSecond = time =>
  `${((Date.now() - time) / 1000).toFixed(2)} s`;

const setLogInterceptor = axiosInstance => {
  const stack = [];
  axiosInstance.interceptors.request.use(
    function (config) {
      const { method, url, params, data } = config;
      const requestInfo = {
        id: v4(),
        method: method.toLocaleUpperCase(),
        url,
        http: 'REQ',
        payload: { params, query: data },
        startTime: new Date(),
        color: getRandomColor(10, 100),
      };
      stack.push(requestInfo);
      config.metadata = { REST_ID: requestInfo.id };
      return config;
    },
    function (error) {
      return Promise.reject(error);
    },
  );
  axiosInstance.interceptors.response.use(
    function (response) {
      const reqIndex = stack.findIndex(
        info => info.id === response.config.metadata.REST_ID,
      );
      const reqInfo = stack.splice(reqIndex, 1)[0];
      apiLog(reqInfo);
      apiLog({
        ...reqInfo,
        http: 'RES',
        duration: getDurationToSecond(reqInfo.startTime),
        payload: response.data,
      });

      return response;
    },
    function (error) {
      const reqIndex = stack.findIndex(
        info => info.id === error.config.metadata.REST_ID,
      );
      const reqInfo = stack.splice(reqIndex, 1)[0];
      apiLog(reqInfo);
      apiLog({
        ...reqInfo,
        http: 'ERR',
        duration: getDurationToSecond(reqInfo.startTime),
        payload: error.response,
      });

      return Promise.reject(error);
    },
  );
};

const apiLog = ({
  http,
  method,
  url,
  duration = 'timeout',
  payload,
  color,
  id,
}) => {
  const text = [`%c${http}%c%c${method}%c%c${url}%c%c${duration}%c\n`];

  const [x, f, s, t] = getGradationColors(4, color, 60);

  const css = [
    `color:white;background-color:${
      http == 'ERR' ? 'rgb(255,71,87)' : x
    };border-radius:${
      http == 'REQ' ? '8px 0 0 0' : '0 0 0 8px'
    };font-weight:bold;padding: 2px 15px;`,
    '',
    `color:white;background:${f};padding: 2px 5px;font-weight:bold`,
    '',
    `color:white;background:${s};padding: 2px 5px;font-weight:bold`,
    '',
    `color:white;background:${t};padding: 2px 5px;border-radius:0 ${
      http == 'REQ' ? '8px 0 ' : '0 8px'
    } 0;font-weight:bold`,
    '',
  ];
  const rest = [...text.concat(css), payload];
  console.log(...rest);
};

module.exports = setLogInterceptor;
